module.exports = __webpack_public_path__ + "img/music.b4c8c240.svg";